import { Injectable } from '@angular/core';
import { AuthService } from '@services/auth/auth.service';
import { environment } from 'environments/environment';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class WebSocketService {
  public webSocket: WebSocket | undefined;
  public receiveBids: any[] = [];
  public receiveBidsChange: BehaviorSubject<any> = new BehaviorSubject(null);
  public getAuctionId: any;
  getUserName: any;
  constructor(private _auth: AuthService) {}

  public openWebSocket(auctionId: string) {
    const accessToken = this._auth.userData['data']['tokens']['access_token'];
    this.webSocket = new WebSocket(
      `${environment.WS_API}?authorization=${accessToken}`
    );

    this.webSocket.onopen = (event) => {
      this.getAuctionId = auctionId;

      this.webSocket?.send(
        JSON.stringify({
          action: 'enterroom',
          roomId: this.getAuctionId,
        })
      );
    };

    this.webSocket.onmessage = (message) => {
      let messageVal = JSON.parse(message.data);

      this.receiveBids = [];
      const bid = Number(messageVal.bidAmount);
      if (bid) {
        const bidInfo = {
          bid,
          first_name: messageVal['userData']['first_name'],
          last_name: messageVal['userData']['last_name'],
          ...messageVal,
        };
        this.receiveBids.push(bidInfo);
        // This section of code used for remove duplicate array
        this.receiveBids = this.receiveBids.reduce((a, b) => {
          if (!a.find((data: any) => data === b)) {
            a.push(b);
          }
          return a;
        }, []);

        this.receiveBidsChange.next(this.receiveBids);
      }
    };

    this.webSocket.onclose = (event) => {};
  }

  public sendMessage(receiveBid: any) {
    console.log({ receiveBid });
    this.webSocket?.send(
      JSON.stringify({
        action: 'message',
        message: receiveBid,
      })
    );
  }

  public closeWebSocket() {
    this.webSocket?.close();
  }
}
